const customClientConfig = {
  // override config from src/config/index.js in here
  inputs: {
    age: {
      currentValue: 30, // initial value
    },
    retirementAge: {
      currentValue: 70, // initial value
    },
  }
}

const state = {
  config: { ...customClientConfig }
}

export default {
  state
};
